import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, objectSpread2 as _objectSpread2, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { useLayoutEffect, mergeProps, filterDOMProps } from '@react-aria/utils';
import React__default, { useRef, useState, useMemo, useEffect } from 'react';
import { Overlay, DismissButton } from 'react-aria';
import { OverlayArrowContext } from './overlay-arrow.esm.js';
import usePopover from '../../../aria/overlay/use-popover.esm.js';
import { useEnterAnimation, useRenderProps } from '../../utils/index.esm.js';

var _excluded = ["state", "isExiting", "UNSTABLE_portalContainer", "onAfterOpen"];
var underLayStyle = {
  position: 'fixed',
  inset: 0
};
function PopoverInner(_ref) {
  var _props$offset;
  var state = _ref.state,
    isExiting = _ref.isExiting,
    UNSTABLE_portalContainer = _ref.UNSTABLE_portalContainer,
    onAfterOpen = _ref.onAfterOpen,
    props = _objectWithoutProperties(_ref, _excluded);
  // Calculate the arrow size internally (and remove props.arrowSize from PopoverProps)
  // Referenced from: packages/@react-spectrum/tooltip/src/TooltipTrigger.tsx
  var arrowRef = useRef(null);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    arrowWidth = _useState2[0],
    setArrowWidth = _useState2[1];
  useLayoutEffect(function () {
    if (arrowRef.current && state.isOpen) {
      setArrowWidth(arrowRef.current.getBoundingClientRect().width);
    }
  }, [state.isOpen, arrowRef]);
  var _usePopover = usePopover(_objectSpread2(_objectSpread2({}, props), {}, {
      offset: (_props$offset = props.offset) !== null && _props$offset !== void 0 ? _props$offset : 8,
      arrowSize: arrowWidth
    }), state),
    popoverProps = _usePopover.popoverProps,
    underlayProps = _usePopover.underlayProps,
    arrowProps = _usePopover.arrowProps,
    placement = _usePopover.placement;
  var ref = props.popoverRef;
  var isEntering = useEnterAnimation(ref, !!placement) || props.isEntering || false;
  var renderProps = useRenderProps(_objectSpread2(_objectSpread2({}, props), {}, {
    defaultClassName: 'react-aria-Popover',
    values: {
      trigger: props.trigger || null,
      placement: placement,
      isEntering: isEntering,
      isExiting: isExiting
    }
  }));
  var style = useMemo(function () {
    return _objectSpread2(_objectSpread2({}, popoverProps.style), renderProps.style);
  }, [popoverProps.style, renderProps.style]);
  var overlayArrowContextProps = useMemo(function () {
    return {
      value: _objectSpread2(_objectSpread2({}, arrowProps), {}, {
        placement: placement,
        ref: arrowRef
      })
    };
  }, [arrowProps, placement]);
  useEffect(function () {
    if (state.isOpen) {
      onAfterOpen === null || onAfterOpen === void 0 || onAfterOpen();
    }
  }, [state.isOpen, onAfterOpen]);
  return /*#__PURE__*/React__default.createElement(Overlay, {
    isExiting: isExiting,
    portalContainer: UNSTABLE_portalContainer
  }, !props.isNonModal && state.isOpen ? /*#__PURE__*/React__default.createElement("div", _extends({
    "data-testid": "underlay"
  }, underlayProps, {
    style: underLayStyle
  })) : null, /*#__PURE__*/React__default.createElement("div", _extends({}, mergeProps(filterDOMProps(props), popoverProps), renderProps, {
    ref: ref,
    slot: props.slot || undefined,
    style: style,
    "data-trigger": props.trigger,
    "data-placement": placement,
    "data-entering": isEntering || undefined,
    "data-exiting": isExiting || undefined
  }), !props.isNonModal && /*#__PURE__*/React__default.createElement(DismissButton, {
    onDismiss: state.close
  }), /*#__PURE__*/React__default.createElement(OverlayArrowContext.Provider, overlayArrowContextProps, renderProps.children), /*#__PURE__*/React__default.createElement(DismissButton, {
    onDismiss: state.close
  })));
}

export { PopoverInner as default };
//# sourceMappingURL=popover-inner.esm.js.map
